import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import { Logo } from "../../Assets.tsx";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";

const Header: React.FC = () => {
  const history = useHistory();
  const [showIcon, setShowIcon] = useState(false);

  const handleLinkClick = (path: string) => {
    history.push(path);
    setShowIcon(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (showIcon) {
        setShowIcon(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [showIcon]);

  useGSAP(() => {
    gsap.from(".gsaplogo", {
      y: -30,
      opacity: 0,
      duration: 1,
      delay: 1,
    });
  });

  useGSAP(() => {
    gsap.from(".gsapRightSideNav", {
      y: -30,
      opacity: 0,
      duration: 1,
      stagger: 0.3,
      delay: 1,
    });
  });

  return (
    <div className="outer">
      <span>
        <a
          href="/"
          onClick={() => handleLinkClick("/")}
          style={{ textDecoration: "none", color: "white" }}
        >
          <img
            className="Header-logo gsaplogo"
            src={Logo}
            alt="imglogo"
            style={{ marginLeft: "10px", height: "70px", borderRadius: "5px" }}
          />
        </a>
      </span>
      <div className={showIcon ? "menu-link mobileMenu-link " : "menu-link"}>
        <ul>
          <a
            href="#"
            onClick={() => handleLinkClick("/")}
            style={{ textDecoration: "none" }}
            className="gsapRightSideNav "
          >
            <li>Home</li>
          </a>
          <a
            href="#Amenities"
            onClick={() => handleLinkClick("/")}
            style={{ textDecoration: "none" }}
            className="gsapRightSideNav"
          >
            <li>Amenities</li>
          </a>
          <a
            href="#Gallery"
            onClick={() => handleLinkClick("/")}
            style={{ textDecoration: "none" }}
            className="gsapRightSideNav"
          >
            <li>Gallery</li>
          </a>
          <a
            href="#About"
            onClick={() => handleLinkClick("/")}
            style={{ textDecoration: "none" }}
            className="gsapRightSideNav"
          >
            <li>About</li>
          </a>
          <a
            href="#Contact"
            onClick={() => handleLinkClick("/")}
            style={{ textDecoration: "none" }}
            className="gsapRightSideNav"
          >
            <li style={{ marginRight: "15px" }}>Contact</li>
          </a>
        </ul>
      </div>

      <div className="humburger_menu gsapRightSideNav">
        <a role="button" onClick={() => setShowIcon(!showIcon)}>
          <MenuIcon
            sx={{ color: "white", fontSize: "35px", marginRight: "20px" }}
          />
        </a>
      </div>
    </div>
  );
};

export default Header;
